module.exports = __webpack_public_path__ + "img/project-new_task_filled.4849f6e5.png";